import { request } from '@/utils/request'
// 此处写形成promise的请求

function getSlides () {
  return request({
    url: '/0.3/slides',
    method: 'get'
  })
}
function getBannerList () {
  return request({
    url: '/web/slides',
    method: 'get'
  })
}
function getColumnList () {
  return request({
    url: '/web/home/column',
    method: 'get'
  })
}
// 亚专科
function getSubspecialityList () {
  return request({
    url: '/sub-specialty/list',
    method: 'get'
  })
}
function getCourseList (params) {
  return request({
    url: '/web/home/course',
    method: 'get',
    params
  })
}
function getLatestList (userId, pageCondition) {
  return request({
    url: '/0.3/' + userId + '/latest-watched/courses',
    method: 'get',
    params: pageCondition
  })
}

function getSearchList (params) {
  return request({
    url: '/columns/pc-search',
    method: 'post',
    params: params
  })
}

export { getSlides, getCourseList, getColumnList, getSubspecialityList, getLatestList, getSearchList, getBannerList }



// WEBPACK FOOTER //
// ./src/api/index.js